/**
 * Orca onboarding wizard route — eagerly registers the route, its search
 * contract and the `beforeLoad` SSR loader, and defers the component + atom
 * imports to `.lazy.tsx`. The orcaloops frame's sheet the lazy chunk's markup
 * depends on comes from `head()` here, as a `?url` link.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { validateOnboardSearch } from "~/lib/orca-admin-onboard-search.ts";
import { orcaReposBeforeLoad } from "~/lib/orca-ssr.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * The route's `head()`: the orcaloops frame's sheet. Extracted so it is
 * unit-testable without the route machinery.
 *
 * @since 1.0.0
 */
export const onboardHead = () => ({ links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/repos/new")({
  validateSearch: validateOnboardSearch,
  beforeLoad: orcaReposBeforeLoad,
  head: onboardHead,
});
